import React from 'react';
import Avatar from '@mui/material/Avatar';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';

function SummaryItem({ icon: Icon, label, value }) {
  if (!value) return null;
  return <div><strong><Icon />{label}</strong><span>{value}</span></div>;
}

function ContextSection({ icon: Icon, title, children }) {
  return <section><h3><Icon />{title}</h3>{children}</section>;
}

function ContactItem({ href, icon: Icon, label, value, copyLabel, onCopy }) {
  if (!value) return null;
  return (
    <div>
      <strong><Icon />{label}</strong>
      <div className="calendar-member-context__contact-value">
        <a href={href}>{value}</a>
        <button type="button" className="calendar-member-context__copy" onClick={() => onCopy(value)} aria-label={copyLabel}>
          <ContentCopyOutlinedIcon />
        </button>
      </div>
    </div>
  );
}

export function CalendarMemberContextView({ member, onBack, onClose, onCopy, onProfileClick, onHistoryClick, t }) {
  const hasContacts = Boolean(member.phone || member.primaryEmail);
  return (
    <div className="calendar-member-context">
      <CalendarMemberContextControls onBack={onBack} onClose={onClose} t={t} />
      <h2><Avatar className={`calendar-member-context__avatar avatar-color-${member.avatarColorIndex}`} aria-hidden="true">{member.initial}</Avatar><button type="button" className="calendar-member-context__name-link" onClick={onProfileClick}>{member.name}</button></h2>
      <div className="calendar-member-context__summary">
        <SummaryItem icon={CakeOutlinedIcon} label={t('common-birthday')} value={member.birthday} />
        <SummaryItem icon={TranslateOutlinedIcon} label={t('calendar-member-preferred-language')} value={member.language} />
        <SummaryItem icon={LocationOnOutlinedIcon} label={t('calendar-member-location')} value={member.location} />
      </div>
      <ContextSection icon={FormatListBulletedOutlinedIcon} title={t('calendar-member-contact-information')}>
        <div className="calendar-member-context__contacts">
          <ContactItem href={`tel:${member.phone}`} icon={PhoneOutlinedIcon} label={t('common-phone')} value={member.phone} copyLabel={t('calendar-copy-phone')} onCopy={onCopy} />
          <ContactItem href={`mailto:${member.primaryEmail}`} icon={MailOutlineOutlinedIcon} label={t('calendar-member-email-primary')} value={member.primaryEmail} copyLabel={t('calendar-copy-email')} onCopy={onCopy} />
        </div>
        {!hasContacts && <p className="note">{t('calendar-member-no-contact-information')}</p>}
      </ContextSection>
      <ContextSection icon={NotesOutlinedIcon} title={t('calendar-member-notes')}>
        <div className="calendar-member-context__notes">
          <p>{member.notes || t('calendar-member-no-notes')}</p>
          {member.notes && (
            <button type="button" className="calendar-member-context__copy" onClick={() => onCopy(member.notes)} aria-label={t('calendar-copy-notes', { defaultValue: 'Copy notes' })} title={t('calendar-copy-notes', { defaultValue: 'Copy notes' })}>
              <ContentCopyOutlinedIcon />
            </button>
          )}
        </div>
      </ContextSection>
      <button type="button" className="calendar-member-context__profile-link" onClick={onProfileClick}>{t('calendar-member-go-to-profile')}</button>
      <button type="button" className="calendar-member-context__history-link" onClick={onHistoryClick}>{t('pma-hac-tab-option8', { defaultValue: 'Activity log' })}</button>
    </div>
  );
}

export function CalendarMemberContextControls({ onBack, onClose, t }) {
  return (
    <div className="calendar-member-context__controls">
      <button type="button" className="back" onClick={onBack} aria-label={t('common-back')}><span className="icon-chevron-left" /></button>
      <button type="button" className="close" onClick={onClose} aria-label={t('common-close')}><span className="icon-close" /></button>
    </div>
  );
}
